import React from 'react';

const PitcherCard = ({ pitcher, side }) => {
  if (!pitcher) return (
    <div className="flex-1 border border-[#658d71] p-3 bg-[rgba(0,0,0,0.1)] flex items-center justify-center">
      <span className="text-[#658d71] text-[10px] uppercase tracking-widest font-bold">TBD</span>
    </div>
  );

  const name = pitcher.fullName || '--';
  const lastName = name.split(' ').slice(1).join(' ') || name;
  const stats = pitcher.stats?.pitching;

  return (
    <div className={`flex-1 border border-[#658d71] p-3 bg-[rgba(0,0,0,0.1)] flex flex-col gap-2 ${side === 'home' ? 'items-end text-right' : 'items-start'}`}>
      <div>
        <span className="text-[9px] text-[#658d71] font-bold uppercase tracking-widest">{side === 'home' ? 'Home SP' : 'Away SP'}</span>
        <p className="text-sm font-black uppercase tracking-wide text-[#d8ceb3] leading-tight">{lastName}</p>
        <p className="text-[9px] text-[#a9c9b1] font-bold">#{pitcher.primaryNumber || '--'} · {pitcher.pitchHand?.code || '--'}HP</p>
      </div>
      {stats && (
        <div className="flex gap-2 flex-wrap">
          {[['ERA', stats.era], ['W', stats.wins], ['L', stats.losses], ['K', stats.strikeOuts], ['IP', stats.inningsPitched], ['WHIP', stats.whip]].map(([label, val]) => (
            <div key={label} className="flex flex-col items-center bg-[rgba(0,0,0,0.2)] border border-[#658d71] px-2 py-1 min-w-[32px]">
              <span className="text-[8px] uppercase tracking-widest text-[#658d71] font-bold">{label}</span>
              <span className="text-xs font-black tabular-nums text-white">{val ?? '--'}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const ProbablePitchers = ({ gameData }) => {
  const away = gameData?.probablePitchers?.away;
  const home = gameData?.probablePitchers?.home;

  return (
    <div className="border border-[#658d71] bg-[rgba(0,0,0,0.08)]">
      <div className="px-3 py-2 border-b border-[#658d71] bg-[rgba(0,0,0,0.1)]">
        <span className="text-xs font-black uppercase tracking-widest text-[#d8ceb3]">Probable Pitchers</span>
      </div>
      <div className="p-3 flex gap-3 items-start">
        <PitcherCard pitcher={away} side="away" />
        <div className="shrink-0 pt-6">
          <span className="text-[#658d71] text-xs font-black">VS</span>
        </div>
        <PitcherCard pitcher={home} side="home" />
      </div>
    </div>
  );
};

export default ProbablePitchers;